import { Component } from 'react'
import { NSARouterMakerResult } from 'namirasoft-account-react'
import { PasswordLayout } from '../PasswordLayout'
import { PasswordEntities } from '../PasswordEntities'
import { PasswordRouterProps } from '../PasswordRouterProps'

export interface TemplateListPageProps extends NSARouterMakerResult, PasswordRouterProps { }

class TemplateListPage extends Component<TemplateListPageProps>
{
    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                action={{
                    description: "See all your password generation Templates and reuse, edit, or remove them."
                }}
                pages={{
                    entity: PasswordEntities.template(this.props),
                    list: {}
                }}
            >
                <></>
            </PasswordLayout >
        )
    }
}

export default TemplateListPage